export function onClassChange(element: Element, callback: (target: Element) => void) {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				callback(mutation.target as Element)
			}
		})
	})
	observer.observe(element, { attributes: true })
	return observer.disconnect.bind(observer)
}
